'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryLanguage = require('./components/PrimaryLanguage.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryLanguage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-primary-language/lib/index.js
// module id = 1500
// module chunks = 1